import React from 'react';
import ReactNativeModal from 'react-native-modal';
import PressableArea from 'src/components/templates/PressableArea';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import CloseIcon from '../../icons/CloseIcon';
const ModalBase = ({ isVisible, onDismiss, style, showCloseButton = false, children, ...rnModalProps }) => {
    const [{ styles, theme, dimensions }] = useTheme(stylesGenerator);
    return (React.createElement(ReactNativeModal, { avoidKeyboard: true, isVisible: isVisible, hideModalContentWhileAnimating: true, onModalHide: () => { }, onBackdropPress: () => {
            onDismiss();
        }, onDismiss: onDismiss, onSwipeComplete: onDismiss, onBackButtonPress: onDismiss, hasBackdrop: true, backdropColor: theme.palette.backdrop.main, backdropOpacity: 1, useNativeDriverForBackdrop: true, style: [styles.container, style], deviceWidth: dimensions.device.width, deviceHeight: dimensions.device.height, ...rnModalProps },
        children,
        showCloseButton && (React.createElement(PressableArea, { style: [styles.close], xAxis: "flex-end" },
            React.createElement(CloseIcon, { onPress: onDismiss, color: "white" })))));
};
const stylesGenerator = createThemedStyle(() => ({
    container: {
        margin: 0,
    },
    close: {
        position: 'absolute',
        backgroundColor: 'rgba(0,0,0,0.3)',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 24,
        right: 12,
        top: 12,
    },
}));
export default ModalBase;
